import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { homeFor } from "../components/ProtectedRoute";
import BackButton from "../components/BackButton";
import GoogleLoginButton from "../components/GoogleLoginButton";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    const next = new URLSearchParams(window.location.search).get("next");
    if (res.ok) navigate(next && next.startsWith("/") && !next.startsWith("//") ? next : homeFor(res.user.role));
    else setError(res.error);
  };

  return (
    <div className="min-h-screen paper-grain flex items-center justify-center px-6 py-12 relative">
      <BackButton className="absolute top-4 left-4" />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
                  className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8" data-testid="login-logo">
          <Logo size={44} />
          <span className="font-serif text-xl font-bold text-[#0B2A45]">Guatemalan Spirits &amp; Fruit Juice</span>
        </Link>
        <div className="bg-white rounded-2xl shadow-xl border border-stone-200 p-8">
          <h1 className="font-serif text-2xl font-semibold text-[#0B2A45] mb-1">Area Riservata</h1>
          <p className="text-sm text-stone-500 mb-6">Accesso agenti di vendita e amministrazione.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                     required data-testid="login-email-input" className="mt-1.5" placeholder="nome@esempio.it" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                     required data-testid="login-password-input" className="mt-1.5" placeholder="••••••••" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="login-submit-btn"
                    className="w-full bg-[#0F4C81] hover:bg-[#0A365C] text-white h-11 rounded-full">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Accedi"}
            </Button>
          </form>
          <div className="flex items-center gap-3 my-5"><span className="flex-1 h-px bg-stone-200" /><span className="text-xs text-stone-400">oppure</span><span className="flex-1 h-px bg-stone-200" /></div>
          <GoogleLoginButton />
          <div className="mt-4 text-center">
            <Link to="/password-dimenticata" className="text-sm text-[#0F4C81] hover:underline" data-testid="forgot-link">
              Password dimenticata?
            </Link>
          </div>
        </div>
        <p className="text-center text-sm text-stone-500 mt-6">
          Non hai un account? <Link to="/registrati" className="text-[#0F4C81] hover:underline font-semibold" data-testid="login-register-link">Registrati</Link>
        </p>
      </motion.div>
    </div>
  );
}
